var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88361 15.6463V15.6463C4.7988 15.8543 3.75076 15.1436 3.54275 14.0588L2.52729 8.76303C2.23608 7.2443 3.23077 5.77712 4.74949 5.48591C6.33498 5.18189 8.31354 4.8025 9.85686 4.50657C11.4243 4.20602 13.447 3.8528 15.0509 3.57917C16.5465 3.324 17.9659 4.31518 18.2516 5.80527C18.2955 6.03425 18.3402 6.26738 18.3849 6.50001",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.80001V17C6 18.1046 6.89543 19 8 19H8.24257C8.66089 19 9 19.3391 9 19.7574C9 20.5821 9.0696 21.802 9.89389 21.7789C10.4531 21.7632 10.653 21.0796 10.9572 20.6101L11.1723 20.2778C11.6884 19.481 12.5731 19 13.5224 19H19.2C20.7464 19 22 17.7466 22 16.2002V9.86662C22 8.35454 21.0116 7.03647 19.5 7C17.8712 6.9607 15.6003 7.00001 14 7.00001H8.79958C7.25319 7.00001 6 8.25361 6 9.80001Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13,
    r: 1,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 1,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 1,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSolid);
export default __webpack_public_path__ + "static/media/messages-solid.45cde87f4eb54d944c06506a3cfdacbc.svg";
export { ForwardRef as ReactComponent };